// extracted by mini-css-extract-plugin
module.exports = {"fix":"vK","modal":"wK","modalContent":"xK","header":"yK","footer":"zK","cancelBtn":"AK","disabled":"BK","formWrapper":"CK","fade":"DK","fade-in":"EK","iframe":"FK"};